export class FireHandler {
  constructor({ World, Emitter, Tick, Animate, PBRProgram, ogl }) {
    const _this = this;
    const gl = World.gl;

    this.match = {
      // materialName: 'StoneShader.001',
      // meshName: 'Ground1',
      objectName: "fireplace"
      // groupName: 'links',
    };

    const { Geometry, Triangle, Program, TextureLoader, Mesh } = ogl;

    const fireShaders = {
      vertex: /* glsl */ `
        
                attribute vec2 uv;
                attribute vec2 position;
                attribute vec4 random;
                attribute float life;
        
                uniform mat4 modelViewMatrix;
                uniform mat4 projectionMatrix;
        
                varying vec2 vUv;
                varying vec4 vRandom;
                varying float vLife;
        
                mat4 billboardMatrix(mat4 inMat4) {
                    mat4 outMat4 = inMat4;
                    outMat4[0][0] = 1.0;
                    outMat4[0][1] = 0.0;
                    outMat4[0][2] = 0.0;
                    outMat4[1][0] = 0.0;
                    outMat4[1][1] = 1.0;
                    outMat4[1][2] = 0.0;
                    outMat4[2][0] = 0.0;
                    outMat4[2][1] = 0.0;
                    outMat4[2][2] = 1.0;
                    return outMat4;
                }

                vec2 rotate2d(vec2 v, float a) ${`{`}
                    float c = cos(a);
                    float s = sin(a);
                    return mat2(c, -s, s, c) * v;
                }
        
                void main() ${`{`}
                    vUv = uv;
                    vRandom = random;
                    vLife = life;
                    vec3 pos = vec3(position.xy, 0.0);

                    // Random rotation
                    pos.xy = rotate2d(pos.xy, mix(-1.0, 1.0, vRandom.w) * 0.5);
                    
                    // Random scale
                    pos.xy *= vec2(mix(0.8, 1.2, vRandom.x) * 0.8, mix(0.8, 1.2, vRandom.y)) * mix(0.7, 1.0, vRandom.z);

                    // Life scale
                    pos.xy *= vec2(mix(2.0, 1.0, vLife) * 0.5, mix(0.8, 1.5, vLife));

                    // Random rotation
                    pos.xy = rotate2d(pos.xy, mix(-1.0, 1.0, vRandom.z) * 0.2);

                    

                    // Random position
                    pos += vec3(
                        mix(-1.0, 1.0, vRandom.z) * 0.5,
                        mix(-1.0, 1.0, vRandom.y) * 0.3,
                        mix(-1.0, 1.0, vRandom.w) * 0.5
                    );

                    // Life position
                    pos.y += life * 1.1;
                    gl_Position = projectionMatrix * billboardMatrix(modelViewMatrix) * vec4(pos, 1.0);
                }
          `,

      fragment: /* glsl */ `
                precision highp float;
        
                uniform float uTime;

                uniform sampler2D tGradient;
                uniform sampler2D tSprite;
                uniform sampler2D tSwirl;
        
                varying vec2 vUv;
                varying vec4 vRandom;
                varying float vLife;
        
                vec2 rotate2d(vec2 v, float a) ${`{`}
                    float c = cos(a);
                    float s = sin(a);
                    return mat2(c, -s, s, c) * v;
                }
        
                void main() ${`{`}
                    vec3 color = vec3(vUv, 1.0);
                    float alpha = 1.0;

                    vec2 swirl = texture2D(tSwirl, vUv + uTime + vRandom.zx * 0.5).rg * 0.15;
                    float sprite = texture2D(tSprite, vUv + swirl).g;
                    vec3 gradient = texture2D(tGradient, vec2(0.5, 1.0 - sprite)).rgb;
                    color = gradient;

                    color *= smoothstep(0.0, 0.4, vLife);
                    color *= smoothstep(1.0, 0.8, vLife);
                    
                    gl_FragColor = vec4(color, alpha);
                }
          `
    };

    const embersShaders = {
      vertex: /* glsl */ `
                attribute vec4 random;
                attribute float life;
        
                uniform mat4 modelViewMatrix;
                uniform mat4 projectionMatrix;
        
                varying vec2 vUv;
                varying vec4 vRandom;
                varying float vLife;
        
                void main() ${`{`}
                    vRandom = random;
                    vLife = life;
                    vec3 pos = vec3(0.0);

                    // Random position
                    pos += vec3(
                        mix(-1.0, 1.0, vRandom.z) * 0.5,
                        mix(-1.0, 1.0, vRandom.y) * 0.3,
                        mix(-1.0, 1.0, vRandom.w) * 0.5
                    );

                    // Life position
                    pos.y += life * mix(4.0, 7.0, vRandom.y);
                    pos.x += life * sin(pos.y + vRandom.w * 6.28);
                    pos.z += life * sin(pos.y + vRandom.y * 6.28);

                    vec4 mVpos = modelViewMatrix * vec4(pos, 1.0);
                    gl_Position = projectionMatrix * mVpos;
                    gl_PointSize = mix(0.2, 2.0, vRandom.x) * 100.0 / length(mVpos.xyz);
                }
          `,

      fragment: /* glsl */ `
                precision highp float;
        
                uniform float uTime;

                uniform sampler2D tGradient;
        
                varying vec2 vUv;
                varying vec4 vRandom;
                varying float vLife;
        
                vec2 rotate2d(vec2 v, float a) ${`{`}
                    float c = cos(a);
                    float s = sin(a);
                    return mat2(c, -s, s, c) * v;
                }
        
                void main() ${`{`}
                    vec2 uv = gl_PointCoord.xy;
                    vec3 color = vec3(1.0);
                    float alpha = 1.0;

                    vec3 gradient = texture2D(tGradient, vec2(0.5, vLife)).rgb;
                    color = gradient;

                    // color *= smoothstep(0.0, 0.2, vLife);
                    // color *= smoothstep(1.0, 0.9, vLife);

                    color *= smoothstep(0.5, 0.1, length(uv - 0.5));
                    
                    gl_FragColor = vec4(color, alpha);
                }
          `
    };

    const fireGradientTexture = TextureLoader.load(gl, {
      src: "assets/images/fire-gradient.png"
    });
    const fireSpriteTexture = TextureLoader.load(gl, {
      src: "assets/images/fire-sprite.png"
    });
    const fireSwirlTexture = TextureLoader.load(gl, {
      src: "assets/images/fire-swirl.jpg",
      wrapS: gl.REPEAT,
      wrapT: gl.REPEAT
    });

    const NUM_FIRE = 12;
    const NUM_EMBERS = 20;
    let fireGeometry, fireProgram;
    let embersGeometry, embersProgram;

    {
      initGeometry();
      handlers();
      Tick.on(update);
    }

    function initGeometry() {
      {
        fireGeometry = new Triangle(gl);
        const random = new Float32Array(NUM_FIRE * 4);
        const life = new Float32Array(NUM_FIRE);
        for (let i = 0; i < NUM_FIRE; i++) {
          random.set(
            [Math.random(), Math.random(), Math.random(), Math.random()],
            i * 4
          );
          life[i] = i / (NUM_FIRE - 1) + Math.random() * 0.1;
        }
        fireGeometry.addAttribute("random", {
          data: random,
          size: 4,
          instanced: 1
        });
        fireGeometry.addAttribute("life", {
          data: life,
          size: 1,
          instanced: 1
        });

        const { vertex, fragment } = fireShaders;
        fireProgram = new Program(gl, {
          vertex,
          fragment,
          uniforms: {
            uTime: World.time,
            tGradient: { value: fireGradientTexture },
            tSprite: { value: fireSpriteTexture },
            tSwirl: { value: fireSwirlTexture }
          },
          transparent: true,
          depthWrite: false
        });
        fireProgram.setBlendFunc(gl.SRC_ALPHA, gl.DST_ALPHA);
      }
      {
        const random = new Float32Array(NUM_EMBERS * 4);
        const life = new Float32Array(NUM_EMBERS);
        for (let i = 0; i < NUM_EMBERS; i++) {
          random.set(
            [Math.random(), Math.random(), Math.random(), Math.random()],
            i * 4
          );
          // life[i] = Math.random();
          life[i] = i / (NUM_FIRE - 1) + Math.random() * 0.1;
        }
        embersGeometry = new Geometry(gl, {
          random: { data: random, size: 4 },
          life: { data: life, size: 1 }
        });

        const { vertex, fragment } = embersShaders;
        embersProgram = new Program(gl, {
          vertex,
          fragment,
          uniforms: {
            uTime: World.time,
            tGradient: { value: fireGradientTexture }
          },
          transparent: true,
          depthWrite: false
        });
        embersProgram.setBlendFunc(gl.SRC_ALPHA, gl.DST_ALPHA);
      }
    }

    function update(delta) {
      {
        const random = fireGeometry.attributes.random;
        const life = fireGeometry.attributes.life;
        for (let i = 0; i < NUM_FIRE; i++) {
          life.data[i] += (0.02 * delta) / 16;
          if (life.data[i] >= 1) {
            life.data[i] -= 1;
            random.data.set(
              [Math.random(), Math.random(), Math.random(), Math.random()],
              i * 4
            );
          }
        }
        random.needsUpdate = true;
        life.needsUpdate = true;
      }
      {
        const random = embersGeometry.attributes.random;
        const life = embersGeometry.attributes.life;
        for (let i = 0; i < NUM_EMBERS; i++) {
          life.data[i] += (0.02 * delta) / 16;
          if (life.data[i] >= 1) {
            life.data[i] -= 1;
            random.data.set(
              [Math.random(), Math.random(), Math.random(), Math.random()],
              i * 4
            );
          }
        }
        random.needsUpdate = true;
        life.needsUpdate = true;
      }
    }

    function handlers() {
      //
    }

    this.add = node => {
      // console.log(node);
      // node.visible = false;

      // Flames + embers
      const fireMesh = new Mesh(gl, {
        geometry: fireGeometry,
        program: fireProgram
      });
      // fireMesh.position.set(-12, -1.5, -7);
      fireMesh.frustumCulled = false;
      fireMesh.setParent(node);

      const embersMesh = new Mesh(gl, {
        geometry: embersGeometry,
        program: embersProgram,
        mode: gl.POINTS
      });
      // embersMesh.position.set(-12, 0, -7);
      embersMesh.position.set(0, 1, 0);
      embersMesh.frustumCulled = false;
      embersMesh.setParent(node);
    };

    this.fallback = () => {
      // console.log('Stone1Handler not used');
    };

    this.destroy = () => {
      //
    };
  }
}
